<template>
    <div>
        <ul class="quiz-list">
            <li v-for="(item, index) in hotQuizData" @click="toggleQuestion(index)">
                <div class="name">{{item.question}}</div>
                <div class="description" v-html="item.answer" v-show="hotIndex === index"></div>
            </li>
        </ul>
    </div>
</template>

<script>
import hotQuizData from '../hotQuizData.js'
    export default {
        data() {
            return {
                hotQuizData,
                num: 0,
                hotIndex: this.$route.query.index || 0,
            }
        },
        methods: {
            toggleQuestion(index) {
                this.hotIndex = this.hotIndex === index ? null : index;
            },
        }
    }
</script>

<style lang="scss" scoped>
.quiz-list {
            background: white;
            margin-top: 20px;
            border-top: 2px solid #ddd;
            li {
            border-bottom: 2px solid #ddd;
            padding: 16px 28px 24px;
                    
                
                .name {
                //    margin-bottom: 32px;
                }
                .description {
                    white-space: pre-wrap;
                    background: #f4f4f4;
                    padding: 24px;
                    margin-top: 32px;
                    font-size: 24px;
                    line-height: 1.8;
                }
            }
        }
</style>